import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { APP_CONFIG } from 'src/app/app.config/app.config';  
import { IUserMessage } from 'src/app/model/api/user-message';
import { BaseService } from '../base/base.service';

@Injectable({
  	providedIn: 'root'
})
export class UserMessageService extends BaseService<IUserMessage> {

    protected urlV2 = "/admin-v02/user-message";    
    protected _cacheValidForSeconds = 360;

    constructor(@Inject(APP_CONFIG) private _config, private _http: HttpClient) {
        super(_config, _http)
    }
}
